// Copyright (c) 2019 Deere & Company

import './index.scss';
import PropTypes from 'prop-types';
import React from 'react';

const handleSearchTextChange = props => event => {

    props.onSearchTextChange( event.target.value );

};

const SearchBarWidget = props => (
    <div className="search-bar">
        <div className="rounded-bar">
            <span className="icon-search" />
            <input
                onChange={handleSearchTextChange( props )}
                placeholder={props.searchPlaceHolder}
                type="text"
                value={props.searchText}
            />
        </div>
        <span className={`search-alert${props.searchText.length === 1 || props.searchText.length === 2 ? ' show' : ' hide'}`}>Enter atleast 3 characters to Search</span>
    </div>
);

SearchBarWidget.displayName = 'RefinableListWidget';
SearchBarWidget.propTypes = {
    onSearchTextChange: PropTypes.func.isRequired,
    searchText: PropTypes.string.isRequired,
    type: PropTypes.func,
    searchPlaceHolder: PropTypes.string,
};

export default SearchBarWidget;
